import saMessages from '../locales/du_NL.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'du-NL',
};
export default saLang;
